<template>
	<DialogV2 ref="dialogRef"
		:confirmLabel="$t('text.save')"
		:cancelLabel="$t('text.cancel')"
		:onConfirm="onConfirm"
		:onCancel="onCancel"
		:loading="loading"
		@close="close()"	
		width="90vw"
	>
		<template #title>
			<v-toolbar-title>
				<span>{{ $t("text.chooseProducts") }}</span>
			</v-toolbar-title>
		</template>

		<!-- Search / Filter Header -->
		<template #header-utility>
			<div style="border-bottom: 1px solid rgb(221, 221, 221);" class="px-8 py-3">
				<div class="d-flex align-center ga-8">
					<div class="d-flex ga-4 flex-grow-1">
						<v-text-field
							variant="outlined"
							density="compact"
							clearable
							hide-details
							prepend-inner-icon="mdi-magnify"
							:placeholder="$t('text.search')"
							v-model="filters.searchString"
							@keyup.enter="search"
							@update:modelValue="filters.searchString = $event"
							@click:clear="clear()"
							data-cy="search-field"
						/>
						<v-btn class="blueButton" theme="dark" elevation="0" @click="search" data-cy="searchButton">
							{{ $t('text.search') }}
						</v-btn>
					</div>
					<ProductFilters :onApplyFilter="applyFilters" :productType="productType" :attribute-sets="attributeSets" />
				</div>
			</div>
		</template>

		<!-- Content -->
		<template #content>
			<div class="content">
				<p class="title">{{ $t('text.chooseProducts') }}</p>
				<p>{{ helpText ?? $t('text.chooseProductsHelp') }}</p>
			</div>
				<!-- TODO: how to pass in a current selection list -->
			<ProductsTable v-model:items="products"
				:total="99999"
				:limit="filters.limit" @update:limit="updateLimit"
				:offset="filters.offset" @update:offset="updateOffset"
				:loading="loading"
				itemValue="product_id"
				v-model:selected="selected"
			/>
		</template>
	</DialogV2>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import omitBy from 'lodash/omitBy'
import DialogV2 from "@/components/common/DialogV2.vue"
import Common from "../../../../mixins/Common.vue"
import ProductFilters from '../ProductFilters.vue'
import ProductsTable from '../tables/ProductsTable.vue'

export default {
	name: 'ProductsDialog',
	components: { DialogV2, ProductsTable, ProductFilters },
	mixins: [ Common ],
	props: {
		modelValue: Array,
		serviceProviderId: String,
		attributeSets: Array,
		helpText: String,
		skipSearch: Boolean,
	},
	data: () => ({
		products: [],
		loading: true,
		selected: [],
		filters: { searchString: '', limit: 10, offset: 0 },
	}),
	methods: {
		async open() {
			this.$refs.dialogRef.open()
			if (this.modelValue) {
				this.selected = JSON.parse(JSON.stringify(this.modelValue))
			}
			await this.getProducts()
		},
		close() {
			this.clear(true)
			this.products = []
			this.selected = []
			this.$refs.dialogRef.close()
		},
		async onConfirm() {
			this.$emit('update:modelValue', this.selected)
			this.close()
		},
		onCancel() {
			this.close()
		},
		async getProducts() {
			try {
				if (this.skipSearch) {
					return
				}
				this.loading = true
				const productFilters = { ...omitBy(this.filters, value => isEmpty(value?.toString())) }
				const clientId = this.$store.state.selectedClient.sys.id
				if (this.serviceProviderId) {
					productFilters.serviceProviderId = this.serviceProviderId
				}
				const r = await this.$httpPost(`/packageTravel/products?clientId=${clientId}`, { ...productFilters })
				this.products = r.products
			}
			catch (error) {
				this.errorTitle = this.$t('text.ERROR')
				this.errorDetail = error.response ? error.response.error : error
			}
			finally {
				this.loading = false
			}
		},
		search() {
			this.filters.offset = 0
			this.getProducts()
		},
		clear(skipGettingProducts) {
			this.filters.offset = 0
			this.filters.categories = []
			this.filters.priceRangeFrom = null
			this.filters.priceRangeTo = null
			this.filters.salesChannels = []
			this.filters.status = []
			this.filters.searchString = ''
			if (!skipGettingProducts) {
				this.getProducts()
			}
		},
		updateLimit(limit) {
			this.filters.offset = 0
			this.filters.limit = limit
			this.getProducts()
		},
		updateOffset(offset) {
			this.filters.offset = offset
			this.getProducts()
		},
		async applyFilters(filters) {
			this.filters = { ...this.filters, ...filters }
			this.getProducts()
		},
	},
};
</script>

<style scoped lang="scss">
.content {
	p {
		font-size: 12px;
		line-height: 16px;
		color: black;
	}

	.title {
		font-size: 17px;
		line-height: 22px;
		font-weight: bold;
	}
}
</style>
